import React, { useEffect, useState } from "react";
import {
  getAuth,
  onAuthStateChanged,
} from "firebase/auth";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  doc,
  updateDoc,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";

import "./stiluri/PaginaProfil.css";

const PaginaProfil = () => {
  const auth = getAuth();
  const firestore = getFirestore();
  const storage = getStorage();

  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    nume: "",
    prenume: "",
    dataNasterii: "",
    gen: "",
    cnp: "",
    telefon: "",
    email: "",
    adresa: "",
    institutia: "",
    role: "",
  });
  const [avatarURL, setAvatarURL] = useState(null);
  const [avatarFile, setAvatarFile] = useState(null);
  const [uploadingAvatar, setUploadingAvatar] = useState(false);

  // Load user auth + data Firestore
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (!firebaseUser) {
        setError("Utilizator neautentificat.");
        setLoading(false);
        return;
      }
      setUser(firebaseUser);

      try {
        // Caut user in Firestore
        const usersRef = collection(firestore, "Utilizatori");
        const q = query(usersRef, where("email", "==", firebaseUser.email));
        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
          const docData = snapshot.docs[0].data();

          setUserData(docData);
          // Initialize formData din datele existente
          setFormData({
            nume: docData.nume || "",
            prenume: docData.prenume || "",
            cnp: docData.cnp || "",
            telefon: docData.telefon || "",
            email: docData.email || firebaseUser.email,
            adresa: docData.adresa || "",
            institutia: docData.institutie || "",
            role: docData.role || "",
          });

          // Avatar
          if (docData.avatar_url) {
            setAvatarURL(docData.avatar_url);
          }

          // Salvează rolul in localStorage
          if (docData.role) {
            localStorage.setItem("userRole", docData.role);
          }
        } else {
          setError("Utilizatorul nu a fost găsit în baza de date.");
        }
      } catch (e) {
        console.error(e);
        setError("Eroare la obținerea datelor utilizatorului.");
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [auth, firestore]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((old) => ({ ...old, [name]: value }));
  };

  // Upload avatar
  const handleAvatarChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setAvatarFile(file);
    // Preview local
    setAvatarURL(URL.createObjectURL(file));
  };

  const handleUploadAvatar = async () => {
    if (!avatarFile || !userData) return;
    setUploadingAvatar(true);

    try {
      const avatarRef = ref(
        storage,
        `pozaprofil_utilizatori/${userData.cnp || userData.email}_avatar`
      );
      await uploadBytes(avatarRef, avatarFile);
      const downloadURL = await getDownloadURL(avatarRef);

      // Update Firestore cu url avatar
      const usersRef = collection(firestore, "Utilizatori");
      const q = query(usersRef, where("email", "==", user.email));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        const docId = snapshot.docs[0].id;
        await updateDoc(doc(firestore, "Utilizatori", docId), {
          avatar_url: downloadURL,
        });
        setAvatarURL(downloadURL);
        alert("Avatar actualizat cu succes!");
      }
    } catch (e) {
      console.error(e);
      alert("Eroare la încărcarea avatarului.");
    }
    setUploadingAvatar(false);
  };

  // Salvare form date personale
  const handleSave = async () => {
    setSaving(true);
    setError("");
    try {
      if (!userData) throw new Error("Date utilizator lipsă");

      // Actualizează documentul utilizator în Firestore
      const usersRef = collection(firestore, "Utilizatori");
      const q = query(usersRef, where("email", "==", user.email));
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const docId = snapshot.docs[0].id;

        await updateDoc(doc(firestore, "Utilizatori", docId), {
         
            nume: formData.nume,
            prenume: formData.prenume,
            cnp: formData.cnp,
            
              telefon: formData.telefon,
              email: formData.email,
              adresa: formData.adresa,
              
          
          institutie: formData.institutia,
          role: formData.role,
        });
        alert("Datele au fost salvate cu succes!");
      } else {
        setError("Document utilizator inexistent.");
      }
    } catch (e) {
      console.error(e);
      setError("Eroare la salvarea datelor.");
    }
    setSaving(false);
  };

  if (loading) return <p>Se încarcă...</p>;
  if (error) return <p className="error-message">{error}</p>;

  return (
    <div className="pagina-profil-container">
      <h2>Profilul Meu</h2>

      <div className="profil-avatar-section">
  <img
    src={avatarURL || "/default-avatar.png"}
    alt="Avatar"
    className="avatar-img"
  />

  <input
    type="file"
    accept="image/*"
    onChange={handleAvatarChange}
    id="avatarInput"
    style={{ display: "none" }}
  />

  <label htmlFor="avatarInput" className="btn upload-avatar-btn" style={{ display: "block", marginTop: "1rem" }}>
    {avatarURL ? "Schimbă fotografia" : "Alege o poză"}
  </label>

  {avatarFile && (
    <button
      onClick={handleUploadAvatar}
      disabled={uploadingAvatar}
      className="btn save-avatar-btn"
      style={{ display: "block", marginTop: "0.5rem" }}
    >
      {uploadingAvatar ? "Se încarcă..." : "Încarcă poza"}
    </button>
  )}
</div>


      <div className="profil-form">
        <label>
          Nume:
          <input
            type="text"
            name="nume"
            value={formData.nume}
            onChange={handleChange}
          />
        </label>

        <label>
          Prenume:
          <input
            type="text"
            name="prenume"
            value={formData.prenume}
            onChange={handleChange}
          />
        </label>





        <label>
          Telefon:
          <input
            type="tel"
            name="telefon"
            value={formData.telefon}
            onChange={handleChange}
          />
        </label>

<label>
  Email:
  <input
    type="email"
    name="email"
    value={formData.email}
    disabled
  />
</label>



<label>
  Instituție:
  <input
    type="text"
    name="institutia"
    value={formData.institutia}
    disabled
  />
</label>
<label>
  Adresă:
  <input
    type="text"
    name="adresa"
    value={formData.adresa}
    disabled
  />
</label>

        <label>
          Rol:
          <input
            type="text"
            name="role"
            value={formData.role}
            onChange={handleChange}
            disabled
            title="Rolul nu poate fi modificat aici"
          />
        </label>

        <button
          className="btn save-btn"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "Se salvează..." : "Salvează modificările"}
        </button>
      </div>
    </div>
  );
};

export default PaginaProfil;
